document.querySelectorAll('.youtube-video-cont iframe').forEach(iframe => {
  let width = parseInt(iframe.getAttribute('width'));
  let height = parseInt(iframe.getAttribute('height'));
  let ratio = height / width * 100;
  iframe.parentNode.style.paddingBottom = ratio + '%';
  iframe.style.display = 'block';
});